import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// ----------------------------------------------------------------------

export function useScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    // The layouts scroll their <main> element instead of the window, so reset
    // that scroller too on route change.
    document.querySelector('main')?.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
